$('.menu__btn').on('click', function(){
  $('.nav__list').toggleClass('nav__list--active')
});


